"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ESCAPE_KEY = 27;
var OnEscape = /** @class */ (function (_super) {
    __extends(OnEscape, _super);
    function OnEscape(props) {
        var _this = _super.call(this, props) || this;
        _this.escapeClick = _this.escapeClick.bind(_this);
        return _this;
    }
    OnEscape.prototype.componentDidMount = function () {
        // // If we are in an environment without a DOM such
        // // as shallow rendering or snapshots then we exit
        // // early to prevent any unhandled errors being thrown.
        // if (typeof document === 'undefined' || !document.createElement) {
        //   return;
        // }
        document.addEventListener('keydown', this.escapeClick);
    };
    OnEscape.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.escapeClick);
    };
    OnEscape.prototype.render = function () {
        return this.props.children || null;
    };
    // HACK: SEE ISSUE https://github.com/Microsoft/TypeScript/issues/1224
    OnEscape.prototype.escapeClick = function (event) {
        if (event.keyCode === ESCAPE_KEY && !this.props.options.disableEscape) {
            this.props.events.onEscaped();
        }
    };
    return OnEscape;
}(React.Component));
exports.default = OnEscape;
//# sourceMappingURL=OnEscape.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/behaviors/OnEscape/OnEscape.js
// module id = 1095
// module chunks = 8